module.exports = __webpack_public_path__ + "img/VIEW.0ab7f527.png";